import React, {Component} from "react";
import ReactTooltip from 'react-tooltip';
import {connect} from "react-redux";
import {Link, NavLink, withRouter} from "react-router-dom";
import {Button as ModalButton, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table} from "reactstrap";

import {toast} from "react-toastify";

import Button from "../../components/button/button";

import {getGames} from "../../../modules/system/game";
import {getGameSessions, resetGameSessionState, getTherapistGameSessionBank, assignPlayerToSession, unassignPlayerFromSession} from "../../../modules/game_session";
import {getPlayers} from "../../../modules/player";
import {getPositions} from "../../../modules/system/position";
import {getSkills} from "../../../modules/system/skill";

import {setPageTitle} from "../../../modules/application/pages";

import {parseQuery} from "../../../transformations/queryString";
import {getMyPlayers} from "../../../modules/player";
import { withWhiteLabelContext } from "react-whitelabel";

import "./therapist-session-bank.css";

class TherapistSessionBank extends Component {
    constructor(props) {
        super(props);
        this.OWNED_SESSION_TYPE = 1
        this.READY_MADE_SESSION_TYPE = 2
        this.state = {
            showAssignModal: false,
            currentSession: {},
            sessions: [],
            players: props.players
        };
        this.removePlayerFromSession = this.removePlayerFromSession.bind(this);
        this.addPlayerToSession = this.addPlayerToSession.bind(this)
    }

    componentWillMount() {      
        const {dispatch, label, token, currentUserId} = this.props;  
        dispatch(resetGameSessionState());
        dispatch(setPageTitle("My Sessions"));
        dispatch(getGames([]));
        dispatch(getPlayers([{"owner_id": currentUserId}]));
        dispatch(getMyPlayers(token));
        dispatch(getPositions([{platform_id:`${label.platform.platform_id}`}]));
        dispatch(getSkills());
    }

    async componentDidMount() {
        const {token} = this.props;
        let sessionsResponse = await getTherapistGameSessionBank(token);
        let sessions;
        if (sessionsResponse.data) {
            sessions = sessionsResponse.data.sessions;
        }
        else {
            sessions = []
        }

        this.setState({sessions: sessions});

        this.props.dispatch(getGameSessions([{"owner_id": this.props.currentUserId},
            {"is_archived": false}, {"is_template": true}], "-id"));

        const queryString = parseQuery(window.location);

        if (queryString && queryString.message) {
            const message = queryString.message;

            toast.success(unescape(message), {
                position: toast.POSITION.TOP_CENTER
            });
        }
    }

    render() {

        const {sessions} = this.state;        

        let that = this;
        return (
            <Row>            
                <Link to="/gameSession">
                    <Button className="ml-4 my-3" text="Create Session" color="primary" onClick={() => {
                        this.props.dispatch(resetGameSessionState());
                    }}/>
                </Link>            
                <Table bordered className="mx-4">
                    <thead>
                    <tr className="pl-2 text-left">
                        <th className="m-0 p-0">
                            Name
                        </th>
                        <th className="m-0 p-0">
                            Players
                        </th>
                        <th className="m-0 p-0">
                            Skills
                        </th>
                        <th className="m-0 p-0">
                            Games
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    {sessions && sessions.map(gameSession => (                        
                        <tr key={"game_session_" + gameSession.id} className="text-left" title={gameSession.notes}>
                            <td className="m-1 p-1">
                                {gameSession.name ? gameSession.name : "<No Name>"}

                                {gameSession.type === that.READY_MADE_SESSION_TYPE ? <span className='ready_made_session_sign'> RESTORE Recommended</span> : ""}
                            </td>
                            <td className="m-1 p-1">
                                {
                                    this.prepareSessionAssignedPlayers(gameSession.players)
                                }
                            </td>
                            <td className="m-1 p-1">
                                {this.gameSessionSkills(gameSession.skills, this.props.skills)}
                            </td>
                            <td className="m-1 p-1">
                                {this.gameSessionGames(gameSession.games)}
                            </td>
                            <td className="m-1 p-1 text-center" style={{width: 120}}>
                                <Button
                                    text="Assign"
                                    className="btn-sm green_button"
                                    onClick={() => {
                                        this.setState({
                                            gameSession: gameSession,
                                            showAssignModal: true
                                        })
                                    }}
                                    color="secondary"
                                />

                                {that.props.user.currentUserId === gameSession.owner_id &&
                                    <NavLink to={{
                                        pathname: `/gameSession/${gameSession.id}`,
                                        gameSession: gameSession
                                    }}>
                                        <Button
                                            className="ml-1 btn-sm"
                                            text="Edit"
                                            onClick={() => {
                                            }}
                                            color="primary"
                                        />
                                    </NavLink>
                                }
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </Table>
                <Modal isOpen={this.state.showAssignModal} className={this.props.className}
                       backdrop={this.state.backdrop}>
                    <ModalHeader>
                        Manage Players for Session<br/>
                        <span className="font-weight-bold">{this.state.gameSession && this.state.gameSession.name}
                        </span> to Player(s)
                    </ModalHeader>
                    <ModalBody>
                        <span className="font-weight-bold">Assigned Players</span><br/>
                        <div className='dialog_player_list'>
                            {this.getAssignedPlayers()}
                        </div>
                        <hr/>
                        <span className="font-weight-bold">Unassigned Players</span><br/>
                        <div className='dialog_player_list'>
                            {this.getAvailablePlayers()}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <ModalButton className="ml-3" color="secondary" onClick={() => {
                            this.setState({
                                showAssignModal: false
                            })
                        }}>Done</ModalButton>
                    </ModalFooter>
                </Modal>            
            </Row>
        );
    }


    prepareSessionAssignedPlayers(gameSessionPlayers) {
        let _players = []
        let _otherPlayers = [];

        let otherPlayersElement = <span></span>;
        if (gameSessionPlayers.length > 5) { 
            for (let i = 0; i < gameSessionPlayers.length; i++) {            
                if (i >= 5) {
                    _otherPlayers.push(gameSessionPlayers[i].name);
                }
                else {
                    _players.push(gameSessionPlayers[i].name);
                }

                let parsedOthers = _otherPlayers.join("<br/>");

                otherPlayersElement = <span> And <span className='session_other_players' data-tip={parsedOthers} data-delay-show='0' data-event='click' data-html={true}><b>{_otherPlayers.length} others</b></span></span>;
            } 
        }
        else {
            for (let i = 0; i < gameSessionPlayers.length; i++) {
                _players.push(gameSessionPlayers[i].name);
            }             
        }

        return <span>{_players.join(", ")}{otherPlayersElement}<ReactTooltip place="top" type="dark" effect="solid"/></span>;
    }

    getAssignedPlayers() {
        if (!this.state.gameSession) {
            return;
        }
        let _players = [];
        let currentGameSession = this.state.gameSession;
        let players = currentGameSession.players;
        for (let i = 0; i < players.length; i++) {
            let currentPlayer = players[i];
            _players.push(
            <div className='player_dialog_player' key={"player_" + currentPlayer.id}>
                        <Button
                            className="ml-3"
                            text="Remove"
                            onClick={() => {
                                this.removePlayerFromSession(this.state.gameSession, currentPlayer.id)
                            }}
                            color="warning"
                        /><span className="ml-2">{currentPlayer.name}</span><br/>
                    </div>
            )
        }

        return _players;
        
    }

    async removePlayerFromSession(gameSession, playerId) {    
        const {token} = this.props;    
        let gameSessionID = gameSession.id;
        const updatedPlayersList = gameSession.players
            .filter(player => {
                return player.id !== playerId
            });

        // const updatedGameSession = {
        //     players: updatedPlayersList
        // };


        let unassignResponse = await unassignPlayerFromSession(playerId, gameSessionID, token);        
        // await getEntity(this.props.dispatch,
        //     updateGameSession(gameSession.id, updatedGameSession));

        if (unassignResponse && unassignResponse.data && unassignResponse.data.success) {
            toast.success("Player has been removed from the session.", {position: toast.POSITION.TOP_CENTER});            
            const _gameSession = this.state.gameSession;
            _gameSession.players = updatedPlayersList;
            this.setState({
                gameSession: _gameSession
            })
        }        
        else {
            toast.warn("Something went wrong... please try again", {position: toast.POSITION.TOP_CENTER});
        }

    };

    findPlayerInGameSession(gameSession, playerID) {
        for (let index in gameSession.players) {
            let currentPlayer = gameSession.players[index];

            if (currentPlayer.id === playerID) {
                return true;
            }
        }

        return false;
    }

    getAvailablePlayers() {
        let that = this;
        if (!this.props.ownedPlayers) {
            return;
        }

        return this.props.ownedPlayers
            .filter(player => {
                if (player.owner !== that.props.currentUserId) {
                    return false
                }

                return that.state.gameSession &&
                that.state.gameSession.players &&
                    !that.findPlayerInGameSession(that.state.gameSession, player.id);
            })
            .map(player => {
                return (
                    <div className='player_dialog_player' key={"player_" + player.id}>
                        <Button
                            className="ml-3"
                            text="Add"
                            onClick={() => {
                                that.addPlayerToSession(that.state.gameSession, player)
                            }}
                            color="primary"
                        /><span className="ml-2">{player.name}</span><br/>

                    </div>
                )
            });
    }

    async addPlayerToSession(gameSession, player) {
        const {token} = this.props;
        let playerID = player.id;
        let gameSessionID = gameSession.id;

        let playerIDs = [];
        const updatedPlayersList = gameSession.players;
        updatedPlayersList.push(player);


        for (var i = 0; i < updatedPlayersList.length; i++) {
            playerIDs.push (updatedPlayersList[i].id);
        }

        // const updatedGameSession = {
        //     players: playerIDs
        // };


        let assignResponse = await assignPlayerToSession(playerID, gameSessionID, token);        
        if (assignResponse && assignResponse.data && assignResponse.data.success) {
            toast.success("Player has been added to the session.", {position: toast.POSITION.TOP_CENTER});

            const _gameSession = this.state.gameSession;
            _gameSession.players = updatedPlayersList;
    
            this.setState({
                gameSession: _gameSession
            })
    
        }
        else {
            toast.warn("Something went wrong... please try again", {position: toast.POSITION.TOP_CENTER});
        }
        //await getEntity(this.props.dispatch, updateGameSession(gameSession.id, updatedGameSession));
        

       
    };

    gameSessionGames = (gameSessionGames) => {
        let gamesArray = [];

        for (let index in gameSessionGames) {
            let currentGame = gameSessionGames[index];
            gamesArray.push(currentGame.name);
        }

        return gamesArray.join(", ");
    };

    gameSessionPlayers = (gameSessionPlayers, players) => {
        let _players = []
        for (let i = 0; i < gameSessionPlayers.length; i++) {
            _players.push(gameSessionPlayers[i].name);
        } 
        return _players.join(", ");
    };

    gameSessionSkills = (gameSessionSkills, skills) => {
        let _skills = []
        for (let i = 0; i < gameSessionSkills.length; i++) {
            _skills.push(gameSessionSkills[i].name);
        } 

        return _skills.join(", ");
    };

    gameSessionPositions = (gameSessionPositions, positions) => {
        return positions
            .filter(position => {
                return gameSessionPositions && gameSessionPositions.includes(position.id);
            })
            .map(position => {
                return position.name
            })
            .join(", ");
    };

    gameSessionLevels = (gameSessionSkills, skills) => {
        return skills
            .filter(skill => {
                return gameSessionSkills.includes(skill.id);
            })
            .map(skill => {
                return skill.name
            })
            .join(", ");
    };
}

const withState = connect(state => {
    const {game, game_session, player, position, skill, user} = state;

    let games = game.games;
    let gameSessions = game_session.game_sessions;
    let players = player.players;
    let ownedPlayers = player.owned_players
    let positions = position.positions;
    let skills = skill.skills;

    return {
        games: games,
        token: user.token,
        user: user,
        ownedPlayers: ownedPlayers,
        gameSessions: gameSessions,
        players: players,
        positions: positions,
        skills: skills,
        currentUserId: user.currentUserId
    };
});

export default withWhiteLabelContext(withRouter(withState(TherapistSessionBank)));



// WEBPACK FOOTER //
// ./src/components/containers/therapist-session-bank/therapist-session-bank.js